import { Sort, PageEvent } from '@angular/material';

export class PaginationModel {
  selectItemsPerPage: number[] = [5, 10, 20, 100];
  pageSize = this.selectItemsPerPage[1];
  pageNumber = 1;
  allItemsLength = 0;
  orderBy: string = '';
  sort(event: Sort) {
    this.orderBy = event.active + (event.direction === '' ? '' : ' ' + event.direction);
  }

  change(pageEvent: PageEvent) {
    this.pageNumber = pageEvent.pageIndex + 1;
    this.pageSize = pageEvent.pageSize;
    this.allItemsLength = pageEvent.length;
  }
}

export class PagedResult<T> {
  paging: PagingHeader;
  links: Link[];
  items: T[];
}

export class PagingHeader {
  totalItems: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

export class Link {
  href: string;
  rel: string;
  method: string;
}



// WEBPACK FOOTER //
// ./src/app/core/models/pagination.ts